// import React from 'react';
// import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
// import PreFormCol from './preFormCol';
// import BtnSpinner from './common/btnSpinners';
// // import $ from 'jquery';
// // import '../css/wizard.css';

// const Wizard = ({selectedComplaints,description,loading, setDescription, handleSubmit, setSelectedComplaints}) => {
//     const [selectedForm, setSelectedForm] = React.useState('pre');

//     // const [selectedComplaints, setSelectedComplaints] = React.useState({});

//     const handleNext = () => {
//         if (selectedForm === 'pre') {
//             setSelectedForm('bill')
//         } else if (selectedForm === 'bill') {
//             setSelectedForm('pay')
//         }
//     }
//     const handlePrevious = () => {
//         if (selectedForm === 'pay') {
//             setSelectedForm('bill')
//         } else if (selectedForm === 'bill') {
//             setSelectedForm('pre')
//         }
//     }

//     return (
//         <>
//             <div
//                 id="wizard1"
//                 role="application"
//                 className="wizard-demo mt-3 wizard clearfix"
//             >
//                 <div className="steps clearfix d-flex justify-content-between px-2">
//                     <div
//                         role="tab"
//                         className={(selectedForm === "pre" ? "current" : "disabled")}
//                         aria-disabled={selectedForm === "pre" ? "false" : "true"}
//                         aria-selected={selectedForm === "pre" ? "true" : "false"}
//                         onClick={() => setSelectedForm('pre')}
//                     >
//                         <a
//                             id="wizard1-t-0"
//                             href="#"
//                             aria-controls="wizard1-p-0"
//                         >
//                             {/* <span className="current-info audible">current step: </span> */}
//                             <span className="number">1</span>{""}
//                             <span className="title fs-sm p-1">Pre-Consultation</span>
//                         </a>
//                     </div>
//                     <div
//                         role="tab"
//                         className={selectedForm === "bill" ? "current" : "disabled"}
//                         aria-disabled={selectedForm === "bill" ? "false" : "true"}
//                         aria-selected={selectedForm === "bill" ? "true" : "false"}
//                         onClick={() => setSelectedForm('bill')}
//                     >
//                         {/* <a
//                             id="wizard1-t-1"
//                             href="#"
//                             aria-controls="wizard1-p-1"
//                         >
//                             <span className="number">2</span>{" "}
//                             <span className="title fs-sm p-1">Consultation Data</span>
//                         </a> */}
//                     </div>
//                     {/* <div
//                         role="tab"
//                         className={(selectedForm === "pay" ? "current" : "disabled")}
//                         aria-disabled={selectedForm === "pay" ? "false" : "true"}
//                         aria-selected={selectedForm === "pay" ? "true" : "false"}
//                         onClick={() => setSelectedForm('pay')}
//                     >
//                         <a
//                             id="wizard1-t-2"
//                             href="#"
//                             aria-controls="wizard1-p-2"
//                         >
//                             <span className="number">3</span>{" "}
//                             <span className="title fs-sm p-1">Payment Details</span>
//                         </a>
//                     </div> */}
//                 </div>
//                 <div className="content clearfix">
//                     <h3 id="wizard1-h-0" tabIndex={-1} className={"title" + (selectedForm === "pre" ? "current" : "")}>
//                         Pre-Consultation Questionnaire
//                     </h3>
//                     <div
//                         id="wizard1-p-0"
//                         role="tabpanel"
//                         aria-labelledby="wizard1-h-0"
//                         className="body"
//                         aria-hidden="true"
//                         style={{ display: selectedForm !== "pre" && "none" }}
//                     >
//                         <p className="mb-4">
//                             Please select the problem areas
//                         </p>
//                         <div className="row g-3 d-flex flex-column">
//                             <div className="col-12 gap-2">
//                                 <PreFormCol selectedComplaints={selectedComplaints} setSelectedComplaints={setSelectedComplaints}/>
//                             </div>

//                             {/* col */}
//                             <div className="col">
//                                 <p>Other complains</p>
//                                 <textarea
//                                     className="form-control"
//                                     placeholder="others complaints"
//                                     onChange={(e)=>setDescription(e.target.value)}
//                                     value={description}
//                                 />
//                             </div>
//                             {/* col */}
//                         </div>
//                         {/* form-row */}
//                     </div>
//                     <h3 id="wizard1-h-1" tabIndex={-1} className={"title" + (selectedForm === "bill" ? "current" : "")}>
//                       Consultation Informtion
//                     </h3>
//                     <div
//                         id="wizard1-p-1"
//                         role="tabpanel"
//                         aria-labelledby="wizard1-h-1"
//                         className="body current"
//                         style={{ display: selectedForm !== "bill" && "none" }}
//                         aria-hidden="false"
//                     >
//                         <p className="mb-4">Wonderful transition effects.</p>
//                         <div className="row g-3">
//                             <div className="col-sm-6">
//                                 <label className="form-label">Wo</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Firstname"
//                                 />
//                             </div>
//                             {/* col */}
//                             <div className="col-sm-6 d-flex align-items-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Lastname"
//                                 />
//                             </div>
//                             {/* col */}
//                             <div className="col-12">
//                                 <label className="form-label">Notes</label>
//                                 <textarea
//                                     className="form-control"
//                                     rows={2}
//                                     placeholder="Enter some notes"
//                                     defaultValue={""}
//                                 />
//                             </div>
//                             {/* col */}
//                         </div>
//                         {/* row */}
//                     </div>
//                     <h3 id="wizard1-h-2" tabIndex={-1} className={"title" + (selectedForm === "pay" ? "current" : "")}>
//                         Payment Details
//                     </h3>
//                     <div
//                         id="wizard1-p-2"
//                         role="tabpanel"
//                         aria-labelledby="wizard1-h-2"
//                         className="body"
//                         style={{ display: selectedForm !== "pay" && "none" }}
//                         aria-hidden="true"
//                     >
//                         <p className="mb-4">
//                             The next and previous buttons help you to navigate through your
//                             content.
//                         </p>
//                         <div className="row g-3">
//                             <div className="col-12">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Credit card number"
//                                 />
//                             </div>
//                             {/* col */}
//                             <div className="col-sm-6">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Name on card"
//                                 />
//                             </div>
//                             {/* col */}
//                             <div className="col-7 col-sm-3 d-flex align-items-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="Exp. date"
//                                 />
//                             </div>
//                             {/* col */}
//                             <div className="col-5 col-sm-3 d-flex align-items-end">
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     placeholder="CVC/CVV"
//                                 />
//                             </div>
//                             {/* col */}
//                         </div>
//                         {/* row */}
//                     </div>
//                 </div>
//                 <div className="actions clearfix">
//                     <ul role="menu" aria-label="Pagination">
//                         {/* <li onClick={handlePrevious} className={selectedForm === "pre" && "disabled"} aria-disabled="true">
//                             <a role="menuitem">
//                                 Previous
//                             </a>
//                         </li> */}
//                         <li 
//                         // onClick={handleNext} 
//                         aria-hidden="false" aria-disabled="true" style={{ display: selectedForm === "pay" && "none", cursor: "pointer" }} >
//                             <button className=' btn btn-success' onClick={()=>handleSubmit()} role="menuitem">
//                                {
//                                 loading ? <div className=' w-100 d-flex justify-content-center'><BtnSpinner/></div>:" Book Appointment"
//                                }
//                             </button>
//                         </li>
//                         {/* <li aria-hidden="false" style={{ display: selectedForm !== "pay" && "none", cursor: "pointer" }}>
//                             <a role="menuitem">
//                                 Finish
//                             </a>
//                         </li> */}
//                     </ul>
//                 </div>

//                 {/* <ConfirmationModal/> */}
//             </div>
//         </>
//     );
// };

// export default Wizard;

import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PreFormCol from './preFormCol';
import BtnSpinner from './common/btnSpinners';

const Wizard = ({
  selectedComplaints,
  description,
  loading,
  setDescription,
  handleSubmit,
  setSelectedComplaints,
}) => {
  const [selectedForm, setSelectedForm] = useState('pre');
  const [showConfirm, setShowConfirm] = useState(false);

  const handleNext = () => {
    if (selectedForm === 'pre') setSelectedForm('bill');
    else if (selectedForm === 'bill') setSelectedForm('pay');
  };

  const handlePrevious = () => {
    if (selectedForm === 'pay') setSelectedForm('bill');
    else if (selectedForm === 'bill') setSelectedForm('pre');
  };

  const confirmBooking = () => {
    setShowConfirm(false);
    handleSubmit();
  };

  return (
    <>
      <div id="wizard1" className="wizard-demo mt-3 wizard clearfix">
      

        {/* === STEP CONTENT === */}
        <div className="content clearfix">
          {selectedForm === 'pre' && (
            <div id="wizard1-p-0" className="body">
              <h3>Pre-Consultation Questionnaire</h3>
              <p className="mb-4">Please select the problem areas</p>

              <div className="row g-3 d-flex flex-column">
                <div className="col-12 gap-2">
                  <PreFormCol
                    selectedComplaints={selectedComplaints}
                    setSelectedComplaints={setSelectedComplaints}
                  />
                </div>

                <div className="col">
                  <p>Other complaints</p>
                  <textarea
                    className="form-control"
                    placeholder="Other complaints"
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                  />
                </div>
              </div>
            </div>
          )}

      
        </div>

        {/* === ACTION BUTTONS === */}
        <div className="actions clearfix mt-3">
          <ul role="menu" className="list-unstyled d-flex justify-content-end gap-2">
            {selectedForm !== 'pre' && (
              <li>
                <Button variant="secondary" onClick={handlePrevious}>
                  Previous
                </Button>
              </li>
            )}
            <li>
              <Button
                variant="success"
                onClick={() => setShowConfirm(true)}
                disabled={loading}
              >
                {loading ? (
                  <div className="w-100 d-flex justify-content-center">
                    <BtnSpinner />
                  </div>
                ) : (
                  'Book Appointment'
                )}
              </Button>
            </li>
          </ul>
        </div>
      </div>

      {/* === CONFIRMATION MODAL === */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to book this appointment?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={confirmBooking}>
            {loading ? <BtnSpinner /> : 'Yes, Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Wizard;
